import $ from "jquery";
import Swiper from 'swiper';
import { Navigation, Pagination, EffectFade } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

class Timeline {
  constructor() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.initTimeline());
    } else {
      this.initTimeline();
    }
  }

  initTimeline() {
    const container = document.querySelector('.timeline-swiper');
    const infoContainer = document.querySelector('.info-swiper');

    if (!container || !infoContainer) {
      return;
    }

    // buscar los elementos de navegación/paginación del infoSwiper (DOM nodes)
    const infoNext = document.querySelector('.swiper-button-next');
    const infoPrev = document.querySelector('.swiper-button-prev');
    const infoPag  = document.querySelector('.swiper-pagination');

    // --- timeline swiper (no necesita navegación aquí, pero puedes añadir módulos si quieres) ---
    const timelineSwiper = new Swiper(container, {
      modules: [], // opcional: [Navigation, Pagination] si quieres nav en el timeline
      slidesPerView: 'auto',
      spaceBetween: 10,
      centeredSlides: true,
      freeMode: true
    });

    // --- info swiper: REGISTRAMOS los módulos necesarios ---
    const infoSwiper = new Swiper(infoContainer, {
      modules: [Navigation, Pagination, EffectFade], // <<--- importante
      slidesPerView: 1,
      effect: 'slide',
      allowTouchMove: true,
      // pasar nodos DOM (más fiable cuando hay varios sliders)
      navigation: {
        nextEl: infoNext || '.swiper-button-next',
        prevEl: infoPrev || '.swiper-button-prev',
      },
      pagination: {
        el: infoPag || '.swiper-pagination',
        clickable: true,
      },
    });

    // función para actualizar años y barra
    const updateTimelineBackground = (swiper) => {
      const index = swiper.activeIndex;
      const slides = swiper.slides;
      const current = $(slides[index]);
      const prev = $(slides[index - 1]);
      const next = $(slides[index + 1]);
      const year = current.data('year');

      $('.year-bg.current').text(year);
      $('.year-bg.prev').text(prev && prev.length ? prev.data('year') : '...');
      $('.year-bg.next').text(next && next.length ? next.data('year') : '...');

      const containerEl = $('.timeline-swiper');
      const slideCenter = current.position().left + current.outerWidth() / 2;
      const containerWidth = containerEl.width();
      const progressPercent = (slideCenter / containerWidth) * 100;
      $('.progress-bar').css('width', progressPercent + '%');
    };

    // sincronización bidireccional
    timelineSwiper.on('slideChange', () => {
      if (infoSwiper.activeIndex !== timelineSwiper.activeIndex) {
        infoSwiper.slideTo(timelineSwiper.activeIndex);
      }
      updateTimelineBackground(timelineSwiper);
    });

    infoSwiper.on('slideChange', () => {
      if (timelineSwiper.activeIndex !== infoSwiper.activeIndex) {
        timelineSwiper.slideTo(infoSwiper.activeIndex);
      }
    });

    // click en años
    $(document).on('click', '.timeline-swiper .swiper-slide', function () {
      const index = $(this).index();
      timelineSwiper.slideTo(index);
    });

    // init
    updateTimelineBackground(timelineSwiper);
    infoSwiper.slideTo(timelineSwiper.activeIndex);

  }
}

export default Timeline;
